import initialState from "../initialState";
import { sortByName } from "../sortEntities";

export const investigationTypes = (state = initialState.investigationTypes, action) => {
	switch (action.type) {
		case "LOAD_INVESTIGATION_TYPES":
			return [...action.payload];

		case "LOAD_INVESTIGATION_TYPE":
			return state.map((x) =>
				x.id !== action.payload.id
					? x
					: {
							...x,
					  }
			);

		case "RENAME_INVESTIGATION_TYPE":
			return state
				.map((x) => (x.id !== action.payload.id ? x : { ...x, name: action.payload.name }))
				.sort(sortByName);

		case "CREATE_INVESTIGATION_TYPE":
			return [...state, action.payload].sort(sortByName);

		case "REMOVE_INVESTIGATION_TYPE":
			return state.filter((et) => et.id !== action.payload.id);

		default:
			return state;
	}
};

export default investigationTypes;
